import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/internal/operators/map';
import { GlobalService } from '../global/global.service';
import { ConfigurationStoreService } from './configuration-store.service';
import { HttpParams } from '@angular/common/http';

interface IDato {
  datos: {}, resultado: [] 
}
@Injectable({
  providedIn: 'root',
})
export class ConfigurationRequestsService {
private userParametriaSubject = new BehaviorSubject<any>(null);
  userParametria$ = this.userParametriaSubject.asObservable();


  constructor(
    private http: HttpClient, 
    private globalService: GlobalService, 
    public configurationStore: ConfigurationStoreService
    ) {}

  getPersonalInformation(params): Observable<any> {
    return this.http
      .get(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/cliente/private/obtenerDatosPrincipales/${params.cuc}`)
  }

  getTypeList(params,cod): Observable<any> {
    return this.http
      .get(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/cliente/private/listarTipoDato/${params.cuc}/${cod}`)
  }

  getTypeListDebito(params,cod): Observable<any> {
    return this.http
      .get(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/cliente/private/listarTipoDatoDebito/${params.cuc}/${cod}`)
  }

  getUbications(params): Observable<any> {
    return this.http
      .get(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/cliente/private/direccion/listarUbigeos/${params.cuc}`)
  }

  getFecha(params): Observable<any> {
    return this.http
      .get(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/cliente/private/obtenerFechaDebito/${params.cuc}`)
  }

  getEmail(params): Observable<any> {
    return this.http
      .get(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/cliente/private/correo/listar/${params.cuc}`)
      .pipe(map((apiResponse: IDato) => this.mapgetEmail(apiResponse)));
  }

  mapgetEmail(apiResponse: { datos: {}, resultado: {} } | any) {
    if(apiResponse.datos){
      return apiResponse.datos;
    }
    return [];
  }

  updateEmail(params): Observable<any> {
    return this.http
      .post(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/cliente/private/correo/actualizar`,params)
  }

  addEmail(params): Observable<any> {
    return this.http
      .post(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/cliente/private/correo/registrar`,params)
  }

  deleteEmail(params): Observable<any> {
    return this.http
      .post(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/cliente/private/correo/eliminar`,params)
  }

  getPhone(params): Observable<any> {
    return this.http
      .get(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/cliente/private/telefono/listar/${params.cuc}`)
      .pipe(map((apiResponse: IDato) => this.mapgetPhone(apiResponse)));
  }

  mapgetPhone(apiResponse: { datos: {}, resultado: {} } | any) {
    if(apiResponse.datos){
      return apiResponse.datos;
    }
    return [];
  }

  updatePhone(params): Observable<any> {
    return this.http
      .post(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/cliente/private/telefono/actualizar`,params)
  }

  addPhone(params): Observable<any> {
    return this.http
      .post(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/cliente/private/telefono/registrar`,params)
  }

  deletePhone(params): Observable<any> {
    return this.http
      .post(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/cliente/private/telefono/eliminar`,params)
  }

  getAccount(params): Observable<any> {
    return this.http
      .get(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/cliente/private/cuentaParticipacion/listar/${params.cuc}`)
      .pipe(map((apiResponse: IDato) => this.mapgetAccount(apiResponse)));
  }
  
  mapgetAccount(apiResponse: { datos: {}, resultado: {} } | any) {
    if(apiResponse.datos){
      return apiResponse.datos;
    }
    return [];
  }

  updateAccount(params): Observable<any> {
    return this.http
      .post(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/cliente/private/cuentaParticipacion/actualizar`,params)
  }

  addAccount(params): Observable<any> {
    return this.http
      .post(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/cliente/private/cuentaParticipacion/registrar`,params)
  }

  deleteAccount(params): Observable<any> {
    return this.http
      .post(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/cliente/private/cuentaParticipacion/eliminar`,params)
  }

  getCorrelativos(params): Observable<any> {
    return this.http
      .get(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/cliente/private/cuentaParticipacion/obtenerCorrelativo/${params.cuc}/${params.idParticipe}`)
      .pipe(map((apiResponse: IDato) => this.mapgetCorrelativos(apiResponse)));
  }
  
  mapgetCorrelativos(apiResponse: { datos: {}, resultado: {} } | any) {
    if(apiResponse.datos && apiResponse.datos.correlativo){
      return apiResponse.datos.correlativo;
    }
    return {};
  }


  getPersoneria(params): Observable<any> {
    return this.http
      .get(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/cliente/private/personeria/listar/${params.cuc}`)
      .pipe(map((apiResponse: IDato) => this.mapgetPersonaria(apiResponse)));
  }
  
  mapgetPersonaria(apiResponse: { datos: {}, resultado: {} } | any) {
    if(apiResponse.datos){
      return apiResponse.datos;
    }
    return [];
  }

  updatePersoneria(params): Observable<any> {
    return this.http
      .post(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/cliente/private/personeria/modificar`,params)
  }

  getDirection(params): Observable<any> {
    return this.http
      .get(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/cliente/private/direccion/listar/${params.cuc}`)
      .pipe(map((apiResponse: IDato) => this.mapgetDirection(apiResponse)));
  }
  
  mapgetDirection(apiResponse: { datos: {}, resultado: {} } | any) {
    if(apiResponse.datos){
      return apiResponse.datos;
    }
    return [];
  }

  updateDirection(params): Observable<any> {
    return this.http
      .post(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/cliente/private/direccion/actualizar`,params)
  }

  addDirection(params): Observable<any> {
    return this.http
      .post(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/cliente/private/direccion/registrar`,params)
  }

  deleteDirection(params): Observable<any> {
    return this.http
      .post(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/cliente/private/direccion/eliminar`,params)
  }

  getCuentasBancarias(params): Observable<any> {
    return this.http
      .get(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/cliente/private/cuentaBancaria/listar/${params.cuc}`)
      .pipe(map((apiResponse: IDato) => this.mapgetCuentaBancarias(apiResponse)));
  }

  addCuentasBancarias(params): Observable<any> {
    return this.http
      .post(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/cliente/private/cuentaBancaria/registrar`,params)
  }
  
  mapgetCuentaBancarias(apiResponse: { datos: {}, resultado: {} } | any) {
    if(apiResponse.datos){
      return apiResponse.datos;
    }
    return [];
  }

  getDebitoAutomatico(params): Observable<any> {
    return this.http
      .get(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/cliente/private/debitoAutomatico/listar/${params.cuc}`)
      .pipe(map((apiResponse: IDato) => this.mapgetInformeAfiliacion(apiResponse)));
  }

  mapgetInformeAfiliacion(apiResponse: { datos: {}, resultado: {} } | any) {
    if(apiResponse.datos){
      return apiResponse.datos;
    }
    return [];
  }

  addDebitoAutomatico(params): Observable<any> {
    return this.http
      .post(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/cliente/private/debitoAutomatico/registrar`,params)
  }

  generarPDF(params): Observable<any> {
    return this.http
      .post(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/cliente/private/debitoAutomatico/generarPDF`,params)
  }

  resetConfigurationData() {
    this.configurationStore.CONFIGURATION_EMAILS= []
    this.configurationStore.CONFIGURATION_PHONES= []
    this.configurationStore.CONFIGURATION_ACCOUNT= []
    this.configurationStore.CONFIGURATION_PERSONERIA= []
    this.configurationStore.CONFIGURATION_DIRECTION= []
    delete this.configurationStore.CONFIGURATION_PERSONAL_INFORMATION
  }

  
    getParametria(params): Observable<any> {
      //const apiFondos = this.globalService.globalEnvironments.apiEndpoint.apiFondos;
      return this.http.get(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/cliente/private/obtenerparametros${params}`);
    }
    setUserParametria(data: any) {
    this.userParametriaSubject.next(data);
  }

  getUserParametria(): any {
    return JSON.parse(localStorage.getItem('userParametria') || 'null');
  }

    generarCodigoAutorizacion(params): Observable<any> {
      const apiFondos = this.globalService.globalEnvironments.apiEndpoint.apiFondos;
      return this.http.get(`${apiFondos}/cliente/private/generarcodigo${params}`);
    }

    validarCodigoAutorizacion(params): Observable<any> {
      const apiFondos = this.globalService.globalEnvironments.apiEndpoint.apiFondos;
    
      const queryParams = new HttpParams()
        .set('codigo', params.codigo)
        .set('tipoDocumento', params.tipoDocumento)
        .set('numeroDocumento', params.numeroDocumento)
        .set('proceso', params.proceso);
    
      return this.http.post(`${apiFondos}/cliente/private/validarcodigo`, null, { params: queryParams });
    }

    
}
